export default {
  MOBILE_ADD_PLUGIN: 'mobile-add-plugin',
  MOBILE_BLOCK_LINK_MODAL: 'mobile-block-link-modal',
  MOBILE_TEXT_LINK_MODAL: 'mobile-text-link-modal',
};
